import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrFuelTruckPage } from './klmr-fuel-truck';

@NgModule({
  declarations: [
    KlmrFuelTruckPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrFuelTruckPage),
  ],
})
export class KlmrFuelTruckPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel-truck/klmr-fuel-truck.module.ts